import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/articles';

type Props = {
  article: Article;
};

export default function ArticleCard({ article }: Props) {
  return (
    <article className="group bg-background-50 border border-background-200 rounded-lg overflow-hidden flex flex-col hover:border-primary-300 transition-colors">
      <Link to={`/article/${article.id}`} className="block" aria-label={article.title}>
        <div className="w-full h-44 overflow-hidden bg-background-100">
          <img
            src={article.cover}
            alt={`${article.title} 话题配图`}
            title={`${article.title} · 黑料今日热点盘点`}
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          />
        </div>
      </Link>
      <div className="p-5 flex flex-col flex-1">
        <div className="flex items-center gap-3 text-xs text-foreground-500 mb-3">
          <span className="px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-900">{article.category}</span>
          <span className="flex items-center gap-1">
            <i className="ri-fire-line text-primary-500" aria-hidden="true"></i>
            {article.heat.toLocaleString()}
          </span>
        </div>
        <h3 className="font-heading text-base md:text-lg font-bold leading-7 text-foreground-950 group-hover:text-primary-700 transition-colors">
          <Link to={`/article/${article.id}`}>{article.title}</Link>
        </h3>
        <p className="mt-3 text-sm text-foreground-600 leading-6 line-clamp-2 flex-1">{article.summary}</p>
        <div className="mt-4 pt-4 border-t border-background-200 flex items-center justify-between text-xs text-foreground-500">
          <span>{article.author}</span>
          <span className="flex items-center gap-1">
            <i className="ri-time-line" aria-hidden="true"></i>
            {article.readMinutes} 分钟读完
          </span>
        </div>
      </div>
    </article>
  );
}